import PatientTemperatureInput from './PatientTemperatureInput';

export default PatientTemperatureInput;
